import React from "react";
import Header from "./Header";
import HelmetTag from "../../../../components/helmet/Helmet";
import Footer from "./Footer";

const Layout = React.forwardRef(({ children }, ref) => {
  return (
    <div id="landing" className="overflow-auto bg-white h-100">
      <HelmetTag
        title="AI-Powered Diagnosis. Real Orthopedic Provider. Zero Guesswork."
        canonical="https://myorthopedicproblem.com/providers"
        description="My Orthopedic Problem help connect patients to leading orthopedic surgeons, physical therapists, and trainers in their area. Start your journey to recovery today!"
        JSONLD={`  {
          "@context": "http://schema.org",
          "@type": "WebPage",
          "name": "Find a Provider",
          "url": "http://myorthopedicproblem.com/providers",
          "image": "https://myorthopedicproblem.com/MyOrthopedicProblem.png?v=4"
        }`}
      />
      <Header />
      <>{children} </>
      <Footer ref={ref} />
    </div>
  );
});

export default Layout;
